import api from "./api";

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function getExistingSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush(teamSlugs, prefs) {
  if (!pushSupported()) throw new Error("This browser doesn't support push notifications");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission was declined — allow it in the browser address bar");
  const reg = await navigator.serviceWorker.register("/sw.js");
  const { data } = await api.get("/push/vapid-key");
  let sub;
  try {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.publicKey) });
  } catch (err) {
    throw new Error("Your browser blocked push subscriptions — notifications don't work in incognito/private mode");
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys, team_slugs: teamSlugs, ...(prefs ? { prefs } : {}) });
  return sub;
}

export async function updatePushTeams(teamSlugs, prefs) {
  const sub = await getExistingSubscription();
  if (!sub) return false;
  await api.post("/push/subscribe", { endpoint: sub.endpoint, keys: sub.toJSON().keys, team_slugs: teamSlugs, ...(prefs ? { prefs } : {}) });
  return true;
}

export async function sendTestPush() {
  const sub = await getExistingSubscription();
  if (!sub) throw new Error("Turn notifications on first");
  await api.post("/push/test", { endpoint: sub.endpoint });
}

export async function disablePush() {
  const sub = await getExistingSubscription();
  if (!sub) return;
  await api.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
  await sub.unsubscribe();
}
